var createBroadcastChannel = function (_a) {
    var channelName = _a.channelName;
    if (typeof BroadcastChannel !== "undefined") {
        return new BroadcastChannel(channelName);
    }
};
var postMessage = function (_a) {
    var broadcastChannel = _a.broadcastChannel, message = _a.message;
    if (broadcastChannel) {
        broadcastChannel.postMessage(message);
    }
    else {
        window.postMessage(message, window.location.origin);
    }
};
export { createBroadcastChannel, postMessage };
